"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputKeys = void 0;
// The const is used to reference the property name in CreateAadAppOutput. When renaming the properties in CreateAadAppOutput, you need to update the const as well.
exports.OutputKeys = {
    configurationId: "configurationId",
    applicationIdUri: "applicationIdUri",
};
//# sourceMappingURL=createOauthOutputs.js.map